import { Layers } from "lucide-react";
import { Link } from "react-router-dom";
import { useAuth } from "../auth";

const linkClass =
  "text-sm text-[var(--text-secondary)] hover:text-[var(--text-primary)] transition-colors";
export function Footer() {
  const { user } = useAuth();
  return (
    <footer className="border-t border-[var(--border-default)] bg-[var(--bg-surface)] mt-auto">
      <div className="max-w-7xl mx-auto px-6 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-10">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2.5 mb-4">
              <div className="w-9 h-9 rounded-lg bg-[var(--text-primary)] flex items-center justify-center">
                <Layers className="w-5 h-5 text-[var(--bg-surface)]" />
              </div>
              <span className="text-xl font-bold">DevSpec</span>
            </div>
            <p className="text-sm text-[var(--text-secondary)] max-w-xs leading-relaxed">
              简洁高效的开发者知识管理平台。支持 Markdown 编辑、AI
              辅助写作和权限管理。
            </p>
          </div>
          <div>
            <h3 className="text-sm font-bold mb-4">产品</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/" className={linkClass}>
                  首页
                </Link>
              </li>
              <li>
                <Link to="/articles" className={linkClass}>
                  文章
                </Link>
              </li>
              <li>
                <Link to="/api-docs" className={linkClass}>
                  API 文档
                </Link>
              </li>
            </ul>
          </div>
          <div>
            <h3 className="text-sm font-bold mb-4">创作</h3>
            <ul className="space-y-3">
              <li>
                <Link to={user ? "/editor" : "/login"} className={linkClass}>
                  写文章
                </Link>
              </li>
              <li>
                <Link to={user ? "/assistant" : "/login"} className={linkClass}>
                  AI 助手
                </Link>
              </li>
              <li>
                <Link
                  to={user ? `/users/${user.id}` : "/login"}
                  className={linkClass}
                >
                  个人中心
                </Link>
              </li>
            </ul>
          </div>
          <div>
            <h3 className="text-sm font-bold mb-4">账户</h3>
            <Link
              to={user ? "/settings" : "/login"}
              className="inline-flex h-10 items-center px-4 rounded-lg text-sm border border-[var(--border-default)] hover:bg-[var(--bg-hover)]"
            >
              {user ? "账户设置" : "登录 / 注册"}
            </Link>
          </div>
        </div>
        <div className="mt-12 pt-7 border-t border-[var(--border-subtle)]">
          <p className="text-xs text-[var(--text-tertiary)]">
            © {new Date().getFullYear()} DevSpec
          </p>
        </div>
      </div>
    </footer>
  );
}
